import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/context'
import { client } from '../config/delcare'
import { useAuth0 } from '@auth0/auth0-react'
import UiInput1 from '../components/ui_input1';
import UiButton1 from '../components/ui_button1';
import UiSpinner from '../components/ui_spinner';

const AgencyInfo = () => {

    const navigate = useNavigate()
    const { logout } = useAuth0()

    const {
        getAllCountries,
        countries,
        hh, ww,
        neonUser,
        fetchDataV2,
    } = useContext(AppContext)

    const [user, setUser] = useState({
        fname: "",
        aname: "",
        marketplace: "",
    })
    const [generalError, setGeneralError] = useState("")
    const [load, setLoad] = useState(false)

    const userChangeHandler = (value, field) => {
        setUser({
            ...user,
            [field]: value
        })
    }

    const registerBusinessHandler = async () => {
        setLoad(true)
        setGeneralError("")

        let valid = true;
        let cols = ['aname', 'marketplace', 'fname']
        Object.keys(user).forEach(x => {
            if (cols.includes(x)) {
                if (["", null, undefined, false].includes(user[x])) valid = false
            }
        })

        if (!valid) {
            setGeneralError("All fields must not be empty")
            setLoad(false)
            return
        }

        let query1 = "REGISTER_BUSINESS_1", params1 = [neonUser.user_int_id, user.aname, user.marketplace]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

        if (resp.length == 0) {
            setLoad(false)
            return
        }

        let query2 = "REGISTER_BUSINESS_2", params2 = [user.fname, resp[0].agency_id, neonUser.user_id]
        await fetchDataV2(query2, params2, "/neon-query-v2")

        setLoad(false)
        window.location.reload()
        return
    }

    const logoutHandler = async (e) => {
        e.preventDefault()
        logout({
            clientId: client,
            logoutParams: {
                returnTo: window.location.origin
            }
        })
        window.localStorage.clear()
    }

    useEffect(() => {
        if (countries.length == 0) getAllCountries()
    }, [])

    useEffect(() => {
        if (neonUser.agency_int_id) {
            setLoad(false)
            navigate("/")
        }
    }, [neonUser])

    return (
        <div className="login-bg-2 w-100 d-flex flex-column justify-content-center py-4 px-2">
            <div className="d-flex justify-content-center mb-3">
                <div className="bispoke-logo align-self-center"></div>
            </div>

            <div style={{ height: hh }} className='w-100'>
                <div className="bg-white shadow-lg login-container" style={{ maxWidth: "450px", margin: "auto" }}>
                    <div className="d-flex gap-1 mb-2" style={{ padding: `0px ${ww < 350 ? 15 : 35}px` }}>
                        <p className="fs-2 mb-0">Business Info</p>
                    </div>
                    <div style={{ padding: `0px ${ww < 350 ? 15 : 35}px` }} className="pb-4">
                        <div style={{ height: 2 }} className="gradiant-h mb-4"></div>
                        <div className="d-flex flex-column gap-3">
                            {generalError != "" && <p className="poppins text-danger">{generalError}</p>}
                            <div>
                                <p className="mb-1 fw-bold poppins">YOUR NAME</p>
                                <UiInput1 field={"fname"} value={user.fname} userChangeHandler={userChangeHandler} />
                            </div>
                            <div>
                                <p className="mb-1 fw-bold poppins">BUSINESS NAME</p>
                                <UiInput1 field={"aname"} value={user.aname} userChangeHandler={userChangeHandler} />
                            </div>
                            <div>
                                <p className="mb-1 fw-bold poppins">COUNTRY</p>
                                <UiInput1 field={"marketplace"} value={user.marketplace} userChangeHandler={userChangeHandler} countries={countries} />
                            </div>
                            <div className="mb-2" />
                            {load ?
                                <div className="d-flex justify-content-center">
                                    <UiSpinner />
                                </div>
                                :
                                <UiButton1 text={"Save"} submit={registerBusinessHandler} />
                            }
                            <div className="d-flex justify-content-center">
                                <a href='#' onClick={logoutHandler} className='text-secondary'>Logout</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgencyInfo